import React, { useState, useEffect, useRef } from 'react';

const HighlightCircle = ({ number, prefixText, suffixText }) => {
    const [count, setCount] = useState(0);
    const [isInView, setIsInView] = useState(false);
    const circleRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsInView(true); // This will trigger the CSS animation for the circle
                    animateCount();
                    // Optional: unobserve after it animates once
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });

        observer.observe(circleRef.current);

        return () => observer.disconnect();

    }, []);

    const animateCount = () => {
        const duration = 2000;
        let startTimestamp = null;

        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            setCount(Math.floor(progress * number));
            if (progress < 1) requestAnimationFrame(step);
        };

        requestAnimationFrame(step);
    };

    const numDigits = Math.max(String(number).length, 1);  // calculate number of digits
    const widthStyle = { width: `${numDigits}ch` };

    return (
      <div className={`highlight-circle ${isInView ? 'in-view' : ''}`} ref={circleRef}>
          <svg className="circle-svg" viewBox="0 0 200 200" width="200" height="200">
              <circle cx="100" cy="100" r="95" stroke="#103158" fill="none" strokeWidth="3"></circle>
          </svg>
          <p>{prefixText} <span className="number" style={widthStyle}>{count}</span> {suffixText}</p>
      </div>
    );
}

export default HighlightCircle;
